import React from 'react';
import Icon from '../../../components/AppIcon';

const insights = [
  {
    id: 1,
    priority: 'critical',
    icon: 'AlertOctagon',
    title: 'Interlock Bypass Risk Escalating',
    body: '3 interlocks currently bypassed in Unit 4 — 50% increase vs last month. Historical data shows bypass durations >72hrs correlate with process deviation events. Recommend immediate review.',
    action: 'Review Interlocks',
    tag: 'Process Safety',
  },
  {
    id: 2,
    priority: 'high',
    icon: 'TrendingUp',
    title: 'Near Miss Rate Trending Up',
    body: 'Near miss reporting has increased 14.2% this period. While reporting culture is improving, 60% of near misses originate from the same 2 work areas. Targeted intervention recommended.',
    action: 'View Near Misses',
    tag: 'Behavioural Safety',
  },
  {
    id: 3,
    priority: 'high',
    icon: 'GraduationCap',
    title: 'Electrical Safety Compliance at 62%',
    body: '6 overdue certifications in electrical safety. 4 personnel are operating in restricted areas with expired credentials. Compliance deadline is 15 days away.',
    action: 'Schedule Training',
    tag: 'Compliance',
  },
  {
    id: 4,
    priority: 'medium',
    icon: 'Wind',
    title: 'NOx Emissions Approaching Threshold',
    body: 'October NOx readings peaked at 50 mg/m³ — 83% of the regulatory limit. Trend suggests threshold breach risk in 3–4 weeks if current trajectory continues.',
    action: 'View Emissions',
    tag: 'Environmental',
  },
];

const priorityConfig = {
  critical: { bg: 'bg-red-500/10', border: 'border-red-500/40', badge: 'bg-red-500/20 text-red-400', dot: 'bg-red-500' },
  high: { bg: 'bg-amber-500/10', border: 'border-amber-500/40', badge: 'bg-amber-500/20 text-amber-400', dot: 'bg-amber-500' },
  medium: { bg: 'bg-blue-500/10', border: 'border-blue-500/40', badge: 'bg-blue-500/20 text-blue-400', dot: 'bg-blue-500' },
};

const AIInsightsPanel = () => {
  return (
    <div className="bg-card border border-border rounded-xl p-5">
      <div className="flex items-center gap-3 mb-5">
        <div className="w-8 h-8 rounded-lg bg-violet-500/10 flex items-center justify-center">
          <Icon name="Sparkles" size={18} color="var(--color-accent)" />
        </div>
        <div>
          <h2 className="text-base font-semibold text-foreground">AI Insights & Recommendations</h2>
          <p className="text-xs text-muted-foreground">Priority-ranked signals from all safety domains</p>
        </div>
        <div className="ml-auto flex items-center gap-2">
          <span className="w-2 h-2 rounded-full bg-emerald-500 animate-pulse" />
          <span className="text-xs text-muted-foreground">Live analysis</span>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-4">
        {insights?.map((insight) => {
          const cfg = priorityConfig?.[insight?.priority];
          return (
            <>
            <div key={insight?.id} className={`${cfg?.bg} border ${cfg?.border} rounded-xl p-4 flex flex-col gap-3`}>
              <div className="flex items-start justify-between gap-2">
                <div className="flex items-center gap-2">
                  <span className={`w-2 h-2 rounded-full flex-shrink-0 mt-0.5 ${cfg?.dot}`} />
                  <span className={`text-xs font-semibold px-2 py-0.5 rounded-full ${cfg?.badge}`}>{insight?.priority?.toUpperCase()}</span>
                </div>
                <span className="text-xs text-muted-foreground bg-muted px-2 py-0.5 rounded-full flex-shrink-0">{insight?.tag}</span>
              </div>
              <div>
                <p className="text-sm font-semibold text-foreground mb-1">{insight?.title}</p>
                <p className="text-xs text-muted-foreground leading-relaxed">{insight?.body}</p>
              </div>
              <button className="mt-auto text-xs font-medium text-accent hover:underline flex items-center gap-1 self-start">
                <Icon name="ArrowRight" size={12} />
                {insight?.action}
              </button>
            </div>
            </>
          );
        })}
      </div>
    </div>
  );
};

export default AIInsightsPanel;